import { createFileRoute } from "@tanstack/react-router";
import heroImg from "@/assets/junk.jpg";
import { ServicePage } from "@/components/ServicePage";
import { services } from "@/lib/service-content";
import { faqJsonLd, serviceJsonLd, breadcrumbJsonLd } from "@/lib/site";

export const Route = createFileRoute("/property-cleanouts")({
  head: () => ({
    meta: [
      { title: services["property-cleanouts"].metaTitle },
      { name: "description", content: services["property-cleanouts"].metaDescription },
      { property: "og:title", content: services["property-cleanouts"].metaTitle },
      { property: "og:description", content: services["property-cleanouts"].metaDescription },
      { property: "og:url", content: "https://anchorsrq.com/property-cleanouts" },
    ],
    links: [{ rel: "canonical", href: "https://anchorsrq.com/property-cleanouts" }, { rel: "preload", as: "image", href: heroImg, fetchpriority: "high" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(breadcrumbJsonLd([{ name: 'Home', url: 'https://anchorsrq.com/' }, { name: 'Services', url: 'https://anchorsrq.com/#services' }, { name: 'Property Cleanouts', url: 'https://anchorsrq.com/property-cleanouts' }])) },
      { type: "application/ld+json", children: JSON.stringify(serviceJsonLd({ slug: "property-cleanouts", name: 'Property Cleanouts', serviceType: 'Property Cleanout', description: "Whole-property clearing for landlords, real estate agents, and owners preparing Sarasota-area homes for sale, rent, or transition — a supporting service from Anchor Services' property care lineup." })) },
      { type: "application/ld+json", children: JSON.stringify(faqJsonLd(services["property-cleanouts"].faqs)) },
    ],
  }),
  component: () => <ServicePage {...services["property-cleanouts"]} heroImg={heroImg} />,
});
